import { FC } from "react"
import { Link, useParams } from "react-router-dom";
import { PROVIDER_PRACTICES_HEADER } from "src/constants/manufacturer";
import { providerProps } from "./types";
import { objectToQueryString } from "src/helpers";
import { TerritoriesSearchProps } from "../territoriesFilter/types";


const CustomProviderPractice: FC<providerProps> = ({ providerPracticesList,title,queryParam }): JSX.Element => {

  console.log("queryParam.....", queryParam)
  const {role, id,p_id} = useParams ();
    console.log("queryParams in practice listing", { queryParam })
    console.log("role", { role })
    console.log("id", { id })
    console.log("p_id", { p_id })
  return (
    <div className="card flex-fill">
      <div className="d-flex flex-column flex-fill">
        <div className="card-header order-1 custom-card-header">
          <h1 className="mb-0 p-0 text-start">{title}</h1>
        </div>
        <div className="order-2 card-body p-0 overflow-y-auto" style={{height: "500px"}}>
          <table className="table table-responsive table-hover">
            <thead className="table-light thead-sticky">
            <tr>
              {PROVIDER_PRACTICES_HEADER.map((tableHeader, index) => (
                  <th key={index} className="text-center top-0" scope="col">
                      <span
                          role={tableHeader.value === '' ? "textbox" : "button"}
                          className={
                            tableHeader.value === '' ?
                                'fw-bold fs-6 lh-base' :
                                'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                          }
                      >
                        {tableHeader.label}
                      </span>
                  </th>
              ))}
            </tr>
            </thead>
            <tbody>
            {providerPracticesList && providerPracticesList.data.length > 0 &&
                providerPracticesList.data.map((item, key) =>
                    <tr key={key} className="align-middle">
                      <td className="text-center">
                        <Link to={{
                          pathname: `/doctor_stats/${item.id}`,
                          search: objectToQueryString({
                            // search_str: item.patient_id,
                            
                            type: item.type,
                            role: "doctor",
                            start_date: queryParam.start_date,
                            end_date: queryParam.end_date,
                            p_id: id,
                            id: (queryParam as TerritoriesSearchProps).id,
                            
                            // detail: true
                          })
                        }}
                              reloadDocument
                              className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover text-center">
                          {item.name}
                        </Link>
                      </td>
                      {/* <td className="text-center"> {item.plan_type_data[0].count}</td>
                    <td className="text-center">{item.plan_type_data[1].count}</td>
                    <td className="text-center">{item?.plan_type_data[3].count}</td> */}
                      <td className="text-center">{item.cases}</td>
                    </tr>
                )
            }
            </tbody>
            <tfoot>
            <tr className="text-center">
              <td><b>Total</b></td>
              <td><b>{providerPracticesList.total}</b></td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};
export default CustomProviderPractice;
